module.exports = __webpack_public_path__ + "img/logoSindimei.ef49a1f9.jpg";